import { defineStore } from 'pinia';
import type { ResourceDictLangValue } from '@/venit/services/model/techpubs-cms';

interface LanguageDisplay {
  name: string;
}

interface TranslationState {
  /** Current language selected by user */
  currentLanguage: string;
  /** Hardcoded languages for login screen (before config is loaded) */
  languages: Record<string, LanguageDisplay>;
  /** Languages configured on backend - mapped by language code */
  languagesConfig: Record<string, ResourceDictLangValue>;
  /** Full list of languages configured on backend */
  allLanguages: ResourceDictLangValue[];
}

export const useTranslationStore = defineStore('translation', {
  state: (): TranslationState => ({
    currentLanguage: localStorage.getItem('currentLanguage') || 'en',
    languages: {
      en: { name: 'English' },
      pl: { name: 'Polski' },
      fr: { name: 'Français' },
    },
    languagesConfig: {
      en: {
        lang: 'en',
        description: 'English',
        translation: true,
        resourceLang: true,
        active: true,
      } as ResourceDictLangValue,
    },
    allLanguages: [],
  }),

  getters: {
    translationLanguages: (state): ResourceDictLangValue[] =>
      state.allLanguages.filter(langConfig => langConfig.translation),
  },

  actions: {
    setCurrentLanguage(newLanguage: string) {
      this.currentLanguage = newLanguage;
      localStorage.setItem('currentLanguage', newLanguage);
    },

    setupLanguages(langConfigurations: ResourceDictLangValue[]) {
      langConfigurations.forEach(langConfig => {
        this.languagesConfig[langConfig.lang] = langConfig;
        this.languages[langConfig.lang] = {
          name: langConfig.description,
        };
      });
      this.allLanguages = langConfigurations;
    },
  },
});
